<!-- @format -->

<template>
  <div id="promotion-history-dialog" class="custom-modal">
    <transition name="el-fade-in" mode="out-in">
      <HolaconLottie v-if="loading == 'updateScreenLoading'" key="create-loading" />
      <el-row v-else>
        <div class="modal-body">
          <el-row>
            <el-col :span="24" class="mb-2">
              <el-button type="primary" :icon="loading == 'listLoading' ? 'fas fa-spinner fa-spin' : 'fas fa-search'" size="mini" @click="isFilterEnabled = !isFilterEnabled" round>{{ $t("onsiteUtilities.promotions.filter") }}</el-button>
            </el-col>
            <transition name="el-zoom-in-top" mode="out-in">
              <el-col :span="24" v-if="isFilterEnabled">
                <div class="mb-2 automated-message-filter">
                  <div class="filter-body">
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="24">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("event.filter.search") }}</label>
                          </div>
                          <el-input v-model="filter.searchTerm" clearable placeholder="..."></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("event.filter.promotions") }}</label>
                          </div>
                          <el-select v-model="filter.promotionIDs" multiple clearable @clear="filter.promotionIDs = []" :placeholder="$t('event.textbox.selectPromotion')">
                            <el-option v-for="promotion in $store.state.promotions.items" :key="promotion.id" :label="promotion.title" :value="promotion.id"></el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("event.filter.participantNo") }}</label>
                          </div>
                          <el-input v-model="filter.participantNo" :placeholder="$t('participantManagament.attendeeList.participant.AttendeeNumber')"></el-input>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                    <el-row :gutter="16" class="mt-2">
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("event.filter.group") }}</label>
                          </div>
                          <el-select v-model="filter.groupIDs" :placeholder="$t('event.textbox.select')" clearable multiple>
                            <el-option v-for="item in $store.state.groups.items" :key="item.id" :label="item.title" :value="item.id">
                              <template>
                                <i class="fas fa-square mr-2" :style="'color:' + item.color"></i>
                                <span>{{ item.title }}</span>
                              </template>
                            </el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                      <el-col :span="12">
                        <div class="registerform-input-container">
                          <div class="custom-label">
                            <label>{{ $t("event.filter.tag") }}</label>
                          </div>

                          <el-select multiple v-model="filter.tagIDs" :placeholder="$t('event.textbox.selectTag')">
                            <el-option v-for="item in $store.state.tags.items" :key="item.id" :label="item.title" :value="item.id">
                              <template>
                                <i class="fas fa-circle mr-2" :style="'color:' + item.color"></i>
                                <span>{{ item.title }}</span>
                              </template>
                            </el-option>
                          </el-select>
                          <!-- <span class="text-danger"> {{ $errorMessage('schemeID', validationErrors) }}</span> -->
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <div class="filter-footer d-flex justify-content-between mt-2">
                    <div class="left-buttons">
                      <el-button size="mini" @click="isFilterEnabled = !isFilterEnabled">{{ $t("onsiteUtilities.promotions.close") }}</el-button>
                    </div>
                    <div class="right-buttons">
                      <el-button size="mini" @click="filterReset" type="primary">{{ $t("onsiteUtilities.promotions.reset") }}</el-button>
                    </div>
                  </div>
                </div>
              </el-col>
            </transition>
          </el-row>
          <div class="promotion-box-container" v-if="historyList.length > 0">
            <div class="promotion-history-header custom-grid-table-header">
              <span>{{ $t("onsiteUtilities.promotions.attendee") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.promotions") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.authorized") }}</span>
              <span>{{ $t("onsiteUtilities.promotions.quantity") }}</span>
            </div>
            <div class="promotion-history-list">
              <div class="item" v-for="item in historyList" :key="item.id">
                <span class="d-flex align-items-center justify-content-center"> <ParticipantMini :type="1" :data="prepareParticipantMini(item)" @click.native="openParticipantDetail(item.id)"/></span>
                <div class="promotion-area">
                  <div class="promotion-item" v-for="promotion in item.promotionReceives" :key="promotion.id">
                    <div class="promotion-title">
                      {{ $store.state.promotions.items.find(x => x.id == promotion.promotionID).title }}
                    </div>
                    <div class="promotion-staff">
                      <span class="promotion-staff-title" v-if="promotion.owner != null">
                        {{ promotion.owner.firstName + " " + promotion.owner.lastName }}
                      </span>
                      <span>
                        {{ $moment(promotion.createDate).format("DD MMMM YYYY, HH:mm") }}
                      </span>
                    </div>
                    <div class="promotion-count">
                      {{ promotion.count }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <HolaconLottieNoData class="w-100" key="create-loading" :source="'holacon-promotion-lottie'" :title="$t('event.table.distPromotions')" @btnAdd="false" @btnRefresh="false" :buttonAdd="false" :buttonRefresh="false" :loading="loading" />
          </div>
        </div>
      </el-row>
    </transition>

    <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading'">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("onsiteUtilities.promotions.close") }}</el-button>
      </div>
      <div class="center-buttons" v-if="historyList.length > 0">
        <el-pagination small background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.page" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="total, sizes, prev, pager, next" :total="filter.total"></el-pagination>
      </div>
      <div class="right-buttons">
        <el-button type="primary" @click="exportList">{{ $t("onsiteUtilities.promotions.download") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import SpeakerAddUpdate from "../../components/SpeakerAddUpdate";
import PaymentDetail from "../../components/PaymentDetail";
import axios from "axios";
import PageCountInfo from "../../components/PageCountInfo";
import ParticipantMini from "../../components/ParticipantMini";
import $ from "jquery";
export default {
  metaInfo: {
    title: "Distributed promotions"
  },
  components: {
    ParticipantMini
  },
  name: "PromotionHistory",
  data() {
    return {
      loading: false,
      timeout: null,
      isFilterEnabled: false
    };
  },
  methods: {
    exportList() {
      this.exportXlsx(16, null, null);
    },
    filterReset() {
      this.$store.commit("promotionResetFilter");
    },
    prepareParticipantMini(row) {
      return {
        firstName: row.firstName,
        lastName: row.lastName,
        tagID: row.tagID,
        id: row.id
      };
    },
    handleSizeChange(take) {
      this.filter.take = take;
      this.$store.commit("setPromotionHistoryTake", take);
    },
    handleCurrentChange(page) {
      this.filter.page = page;
      $("html, body").animate({ scrollTop: 0 }, 350);
    }
  },
  mounted() {},
  async created() {
    this.loading = "updateScreenLoading";
    if (this.timeout != null) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await Promise.all([this.$store.dispatch("getGroups"), this.$store.dispatch("getTags"), this.$store.dispatch("getPromotionHistory")]);
      this.loading = false;
    }, 500);
  },
  computed: {
    filter() {
      return this.$store.getters.getPromotionFilter;
    },
    historyList() {
      return this.$store.getters.getPromotionHistory;
    }
  },
  watch: {
    filter: {
      deep: true,
      async handler() {
        this.loading = "listLoading";
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch("getPromotionHistory");
          this.loading = false;
        }, 500);
      }
    }
    // "$store.state.promotionhistory.filter.searchTerm": function () {
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     this.$store.dispatch("getPromotionHistory");
    //   }, 500);
    // },
    // "$store.state.promotionhistory.filter.promotionIDs": function (val) {
    //   this.$store.dispatch("getPromotionHistory");
    // },
  }
};
</script>

<style lang="less" scoped>
#promotion-history-dialog {
  .promotion-history-header {
    grid-template-columns: 180px 1fr 1fr 90px;
  }
  .promotion-history-list {
    .item {
      padding: 10px;
      gap: 0.5rem;
      display: grid;
      grid-template-columns: 180px 1fr;
      border-radius: 8px;
      background-color: #f1f1f1;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }

      .promotion-area {
        display: flex;
        flex-direction: column;
        gap: 10px;
        color: #292f3b;
        .promotion-item {
          display: grid;
          grid-template-columns: 1fr 1fr 90px;
          align-items: center;
          .promotion-title {
            font-size: 14px;
            font-weight: bold;
          }
          .promotion-staff {
            display: flex;
            flex-direction: column;
            gap: 4px;
            .promotion-staff-title {
              font-weight: 500;
            }
          }
          .promotion-count {
            font-size: 14px;
            font-weight: bold;
            background-color: white;
            color: black;
            padding: 4px;
            height: 30px;
            width: 30px;
            text-align: center;
            border-radius: 10px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/event/PromotionHistory.vue